import { useEffect, useRef } from "react";

const isMonitoringEnabled = (): boolean => {
  const monitoringOn = localStorage.getItem('monitoringOn');
  if (!monitoringOn) return false;

  const twoHoursAgo = Date.now() - (2 * 60 * 60 * 1000);
  const parsedTimestamp = parseInt(monitoringOn, 10);

  return !isNaN(parsedTimestamp) && parsedTimestamp >= twoHoursAgo;
};

const RemoteMonitor = (props: { children: any; }) => {
  const trackerRef = useRef<any>(null);

  useEffect(() => {
    if (isMonitoringEnabled()) {
      // Dynamic import - only loads @openreplay/tracker when needed
      Promise.all([
        import('@openreplay/tracker'),
        import('@openreplay/tracker-assist')
      ]).then(([{ default: Tracker }, { default: trackerAssist }]) => {
        trackerRef.current = new Tracker({
          projectKey: "KYbd6KJH3xj53FOoo7Xx",
          __DISABLE_SECURE_MODE: process.env.NODE_ENV !== 'production',
        });

        trackerRef.current.use(trackerAssist());
        trackerRef.current.start();
      }).catch((error) => {
        console.error('Failed to load OpenReplay tracker:', error);
      });
    }

    return () => {
      if (trackerRef.current) {
        trackerRef.current.stop();
      }
    };
  }, []);

  return props.children;
};

export default RemoteMonitor;